import React from "react";
import Modal from "../../../components/Modal";
import H5 from "../../../components/Typography/H5";
import Caption from "../../../components/Typography/Caption";
import { useFetchApi } from "../../../hooks/useFetchApi";

const DeleteModal: React.FC<{
  id: string | number;
  data: any;
  status: boolean;
  onClose: any;
  onSuccess: any;
}> = ({ data, status, onClose, onSuccess }): React.ReactElement => {
  const { execute } = useFetchApi("/api/roles", {}, "DELETE", onSuccess);

  const handleSubmit = (e: any) => {
    execute({ id: data.id });
    const _e = { ...e, target: { ...e.target, id: "delete" } };
    onClose(_e);
  };

  const handleClose = (e: any) => {
    const _e = { ...e, target: { ...e.target, id: "delete" } };
    onClose(_e);
  };

  return (
    <Modal status={status} onClose={handleClose} onSubmit={handleSubmit}>
      <H5>Are you sure you want to delete ?</H5>
      <Caption className="text-center mt-4 mb-4">
        This action is irreversible{" "}
      </Caption>
    </Modal>
  );
};

export default DeleteModal;
